module.exports = __webpack_public_path__ + "141d4a85/img/arrow-share-icon.00a12c29.svg";